import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

class VariantSku extends Component {
    render() {
        const { variant_sku, skuArrayIndex, handleKeyPress, handleVariantSkuInputChange } = this.props

        return (
            <div className="variant-wrapper">
                <div className="variant-item-content">
                    <div className="variant-label variant-title">
                        {variant_sku.sku_text.map((sku_text, i) => {
                            const line = [
                                <span key={'sku_text-' + i} className="variant_piece">{sku_text.txt}</span>,
                                <span key={'sku_sep-' + i} className="variant_title_seperator"> / </span>
                            ]
                            return line
                        })}
                    </div>
                    <div className="variant-value-collection">
                        <div className="variant-item">
                            <input className="variant-value" type="text" value={variant_sku.sku} placeholder=""
                                onKeyPress={e => handleKeyPress(e)}
                                onChange={e => handleVariantSkuInputChange(e.target.value, skuArrayIndex, 'sku')}
                            />
                            <NumberFormat className="variant-value" value={variant_sku.price} placeholder="0.00" prefix={'$'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true}
                                onKeyPress={e => handleKeyPress(e)}
                                onValueChange={e => handleVariantSkuInputChange(e.value, skuArrayIndex, 'price')}
                            />
                            <NumberFormat className="variant-value" value={variant_sku.inventory === null ? '' : variant_sku.inventory} placeholder="Inventory of item" decimalScale={0} fixedDecimalScale={true} thousandSeparator={true}
                                onKeyPress={e => handleKeyPress(e)}
                                onValueChange={e => handleVariantSkuInputChange(e.value, skuArrayIndex, 'inventory')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default VariantSku



// WEBPACK FOOTER //
// ./src/components/admin/products/variants/VariantSku.js